<template>
  <ui-modal
    :show="showBetting"
    type="tag"
    title="竞猜投注"
    iconType="quiz_2"
    @close="showBetting = false"
  >
    <div class="bg-popup"></div>
    <div class="amount">
      <div class="inner">
        <div class="left-box">
          <div class="icon-bg">
            <div class="name">
              <div class="label-box">
                <span class="label-shadow">{{ info.obj_name }}</span>
                <span class="label-text">{{ info.obj_name }}</span>
              </div>
            </div>
            <div class="icon">
              <div
                class="head"
                :style="{
                  'background-image': `url(${info.obj_avatar})`,
                }"
              ></div>
              <div class="frame"></div>
            </div>
          </div>

          <div class="info">
            <div class="label-box odd">
              <span class="label-shadow">赔率 {{ info.lossRate ? info.lossRate : '0' }}</span>
              <span class="label-text">赔率 {{ info.lossRate ? info.lossRate : '0' }}</span>
            </div>
            <div class="label-box rating">
              <span class="label-shadow">支持率 {{Number(info.ratios * 100).toFixed(0) || 0 }} %</span>
              <span class="label-text">支持率 {{Number(info.ratios * 100).toFixed(0) || 0 }} %</span>
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="odds-rate">
            <div class="odds">
              <span class="title">赔率: </span>
              <span>{{ info.lossRate }}</span>
            </div>
            <div class="rate">
              <span class="title">支持率: </span>
              <span>{{Number(info.ratios * 100).toFixed(0) || 0 }} %</span>
            </div>
          </div>
          <div class="amount-get">
            <span class="title">竞猜正确后可获得:</span>
            <i></i>{{ amount_get }}
          </div>
          <div class="amount-predict">
            <div class="title">投注金额:</div>
            <ul class="amount-list">
              <li
                v-for="(amount, key) in amountList"
                :key="key"
                @click="chooseAmount(amount)"
              >
                <ui-frame-bg :colorType="quizAmount == amount ? 'yellow' : 'blue'" hook>
                  <div class="label-box">
                    <div class="label-shadow">{{ amount }}</div>
                    <div class="label-text">{{ amount }}</div>
                  </div>
                </ui-frame-bg>
              </li>
              <li :class="{ 'other-amount': quizAmount == inputAmount ? 'white-all' : '' }" @click="handleOther(true)">
                <ui-frame-bg :colorType="quizAmount == inputAmount ? 'white-all' : 'blue'" hook>
                  <div class="label-box" v-show="!otherAmount">
                    <div class="label-shadow">其他金额</div>
                    <div class="label-text">其他金额</div>
                  </div>
                  <input
                    ref="input"
                    v-show="otherAmount"
                    v-model="inputAmount"
                    :class="{ 'active': quizAmount == inputAmount }"
                    type="number"
                    oninput="this.value = this.value> 999999 ? 999999 : Math.abs(this.value)"
                    @blur="handleOther(false)"
                  />
                </ui-frame-bg>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="amount-surplus">
        <div class="label-box">
          <div class="label-shadow">余额</div>
          <div class="label-text">余额</div>
        </div>
        <i></i>
        <div class="label-box">
          <div class="label-shadow">{{ amount.quizRemainNum }}</div>
          <div class="label-text">{{ amount.quizRemainNum }}</div>
        </div>
      </div>
      <ui-frame-bg class="betting-btn" colorType="yellow" @click.native="betting" hook>
        <div class="label-box">
          <div class="label-shadow">投注</div>
          <div class="label-text">投注</div>
        </div>
      </ui-frame-bg>
    </div>
    <Prompt ref="prompt" hook="px"></Prompt>
  </ui-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/service/index'
import Prompt from '@/components/prompt'
import UiModal from '@/components/ui-modal.vue'
import UiFrameBg from '@/components/ui-frame-bg.vue'

export default {
  components: {
    Prompt,
    UiModal,
    UiFrameBg
  },
  data() {
    return {
      info: {},
      other: {},
      showBetting: false,
      amountList: [10, 20, 50, 100, 500],
      quizAmount: 50,
      inputAmount: 0,
      otherAmount: false,
      inRequest: false,
      // ratios: this.info.ratios * 100 || 0
      maxInputValue: 999999
    }
  },
  watch: {
    inputAmount(newAmount) {
      console.log('newAmount', newAmount)
      // if (newAmount && newAmount > 0) {
        this.quizAmount = newAmount
      // } else {
      //   this.quizAmount = this.amountList[2]
      // }
    }
  },
  computed: {
    ...mapState(['scale', 'token', 'amount']),
    amount_get: function () {
      return Math.round(this.info.lossRate * this.quizAmount)
    }
  },
  methods: {
    ...mapActions(['reqUserInfo','reqRedDotState']),
    hideModal() {
      this.showBetting = false
      this.quizAmount = this.amountList[2]
      this.inputAmount = 0
      this.info = {}
    },
    chooseAmount(amount) {
      if (this.quizAmount != amount) {
        this.quizAmount = amount
      }
    },
    handleOther(bool) {
      if (!this.inputAmount || this.inputAmount == 0) {
        // input为空时，才会控制显示隐藏
        this.otherAmount = bool

        if(bool) {
          this.quizAmount = this.inputAmount
        } else {
          this.quizAmount = this.amountList[2]
        }

        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      } else {
        // input不为空，为选中状态
        this.quizAmount = this.inputAmount
      }
    },
    async betting() {
      if (Number(this.amount.quizRemainNum) >= Number(this.quizAmount)) {
        if (!this.inRequest) {
          this.inRequest = true

          let data = {
            // token: decodeURIComponent(this.token),
            quizId: Number(this.info.question_id),
            answerCode: this.info.answer_code,
            goldNum: Number(this.quizAmount)
          }
          if(!this.token) return;
          let response = await api.submitQuiz(this.token, data)
          if (response.status == 200) {
            if (response.data === true) {
              
              // 更新余额
              this.reqUserInfo(true)
              this.reqRedDotState()
              this.$refs.prompt.setMsg('竞猜成功～')
              setTimeout(() => {
                this.hideModal()
              }, 1500)
            } else {
              this.$refs.prompt.setMsg(response.data)
            }
          } else {
            this.$refs.prompt.setMsg(response.data)
          }

          this.inRequest = false
        }
      } else {
        this.$refs.prompt.setMsg('您的竞猜币不够，请更改投注金额')
      }

      const trackEventFN = (eventName, properties) => {
        if (typeof tapdb == 'undefined') return
        tapdb.trackEvent(eventName, properties)
      }
      const commonProperties = {
        '#schedule_id': this.other.schedule_id,
        '#match_title': this.other.match_title,
        '#match_id': this.other.match_id,
        '#answer_name': this.info.answer_name,
        '#vote_name': this.info.obj_name
      }
      const eventTarget = {
        schedule: '赛事投票',
        live: '实时投票',
        rankpk: '排行PK',
        disusepk: '淘汰PK'
      }
      if (this.other.stype == 1) {
        // 战队预测
        trackEventFN(eventTarget[this.other.subType], commonProperties)
      } else {
        // console.log('shangbao')
        // live:'实时投票', rankpk:'排行PK', disusepk:'淘汰PK'
        trackEventFN(eventTarget[this.other.subType], {
          ...commonProperties,
          '#type': this.other.type
        })
      }

      // 埋点
      //       if(typeof tapdb == 'undefined') return;

      //       const eventTarget = {
      //         schedule:'赛事投票',
      //         live:'实时投票',
      //         rankpk:'排行PK',
      //         disusepk:'淘汰PK'
      //       }
      // // 这里默认是 赛事投票
      //       if(this.other.stype == 1) {
      //         // 战队预测
      //         tapdb.trackEvent(eventTarget[this.other.subType], {
      //           '#schedule_id': this.other.schedule_id,
      //           '#match_title': this.other.match_title,
      //           '#match_id': this.other.match_id,
      //           '#answer_name': this.info.answer_name,
      //           '#vote_name': this.info.obj_name
      //         });
      //       } else   {
      //         // 这三个走这个埋点
      //         // live:'实时投票',
      //         // rankpk:'排行PK',
      //         // disusepk:'淘汰PK'
      //         tapdb.trackEvent(eventTarget[this.other.subType], {
      //           '#schedule_id': this.other.schedule_id,
      //           '#match_title': this.other.match_title,
      //           '#match_id': this.other.match_id,
      //           '#type': this.other.type,
      //           '#answer_name': this.info.answer_name,
      //           '#vote_name': this.info.obj_name
      //         });
      //       }
    },
    quiz(info, other) {
      // console.log('info',info);
      // console.log('other',other);
      this.showBetting = true
      this.info = info
      this.other = other
    },
    handleInput(event) {
      // 如果输入的值大于最大值，则将其限制为最大值
      if (event.target.value > this.maxValue) {
        this.inputValue = this.maxValue;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/quiz/betting';
</style>